export { default } from './FooterInput';
